/**
 * Resolves the href for an IQ source entry. The IQ service returns the link
 * under `source` for some payloads and `url` for others; `url` wins when both
 * are present. Returns an empty string when the source carries no link, so
 * callers can fall back to rendering plain text.
 *
 * @param {{ url?: string, source?: string }|null|undefined} source
 * @returns {string}
 */
export function resolveIQSourceHref(source) {
  if (!source || typeof source !== "object") {
    return "";
  }
  return source.url || source.source || "";
}
